import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-new-desk',
  templateUrl: './turns-new-desk.component.html',
  styleUrls: ['./turns-new-desk.component.scss']
})
export class TurnsNewDeskComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
